import { render, staticRenderFns } from "./AppSignUpAuthPage.vue?vue&type=template&id=400cff16&scoped=true"
import script from "./AppSignUpAuthPage.vue?vue&type=script&lang=js"
export * from "./AppSignUpAuthPage.vue?vue&type=script&lang=js"
import style0 from "./AppSignUpAuthPage.vue?vue&type=style&index=0&id=400cff16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400cff16",
  null
  
)

export default component.exports